import CoffeeLink from '../common/CoffeeLink';

const CoffeeBanner = () => (
  <section className="coffee-banner-inline">
    <p>Hello! If you find this content helpful, please consider
      supporting this project. 🙂
    </p>
    <CoffeeLink placement="article-inline" />
  </section>
);

export default CoffeeBanner;
